export default function getFirstAuthorEmail(authors) {
  if (!authors) {
    return undefined;
  }

  return authors.find((a) => a.firstAuthor)?.emailAddress;
}
